import React, { useState } from 'react';
import axios from 'axios';
import useLocalStorage from 'use-local-storage';
import { useWorkspace } from '../../../context/WorkspaceContext';

const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;


export const PinterestLoginButton = ({ onClick }) => {
    const [isLoading] = useState(false);
    const [activeWorkspace] = useLocalStorage("activeWorkspace");
    const { idToken } = useWorkspace();

    const handleClick = () => {
        if (!idToken) {
            console.error('idToken is not set');
            return;
        }

        if (!activeWorkspace) {
            console.error('No active workspace found');
            return;
        }

        axios.get(BACKEND_API_URL + '/api/pinterest/oauth', {
            headers: { Authorization: `Bearer ${idToken}` }
        })
            .then(response => {
                localStorage.setItem('pinterest_workspace_id', activeWorkspace.id);
                window.open(response.data, '_blank');
            })
            .catch(error => {
                console.error(error);
            });
    };

    return (
        <button
            className="flex items-center text-white p-4 w-full justify-between h-[70px] bg-red-600 hover:bg-red-700 rounded-lg transition-colors duration-200"
            onClick={handleClick}
            disabled={isLoading}
        >
            {isLoading ? 'Loading...' : (
                <>
                    <div className="mr-3 w-12 h-12 bg-white rounded-full flex items-center justify-center">
                        <img
                            src={'../socials/pinterest-logo.svg'}
                            alt="Pinterest Logo"
                            className="w-8 h-8"
                        />
                    </div>
                    {'Pinterest'}
                </>
            )}
            <div></div>
        </button>
    );
};

export default PinterestLoginButton; 